import type { Dependencies } from "@redux/store";
import { createAction, createAsyncThunk } from "@reduxjs/toolkit";
import type { ApproveExternalProviderPaymentBody } from "@shared-kernel/application/ports/admin/admin-repository";

export const approveExternalProviderPayment = createAsyncThunk<void, ApproveExternalProviderPaymentBody, { extra: Partial<Dependencies> }>(
  "externalProviderPayments/approveExternalProviderPayment",
  async (body: ApproveExternalProviderPaymentBody, { extra: { adminRepository } }) => {
    return adminRepository!.approveExternalProviderPayment(body);
  },
);

export const resetApproveExternalProviderPayment = createAction("externalProviderPayments/resetApproveExternalProviderPayment");
